function clearSelectionForm() {
  // テキスト入力フォームの値をクリア
  document.getElementById('project_title').value = '';
  // 債権者・債務者フィールドはログイン時のみ表示されるためnullチェック
  const creditorName = document.getElementById('creditor_name');
  if (creditorName) creditorName.value = '';
  const debtorName = document.getElementById('debtor_name');
  if (debtorName) debtorName.value = '';

  // プルダウンの選択をクリア（先頭の項目を選択状態に）
  document.getElementById('status').tomselect.setValue('');
  document.getElementById('legal_type').tomselect.setValue('');
}

// onclick属性から呼び出せるように、関数をグローバルスコープに設定
window.clearSelectionForm = clearSelectionForm;
